export default __webpack_public_path__ + "8b98ff84e242d89749ff3819fdf9e375.svg";